import { render } from "./HistoryTable.vue?vue&type=template&id=08a2de20&scoped=true"
import script from "./HistoryTable.vue?vue&type=script&lang=js"
export * from "./HistoryTable.vue?vue&type=script&lang=js"

import "./HistoryTable.vue?vue&type=style&index=0&id=08a2de20&lang=sass&scoped=true"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a2de20"]])

export default __exports__